'use client';

import React from 'react';
import { trackPhoneCall, trackWhatsAppClick, trackOfferteButtonClick } from '@/lib/conversions';

interface PhoneCTALinkProps {
  href: string;
  className?: string;
  children: React.ReactNode;
  location: string;
  type?: 'phone' | 'whatsapp' | 'offerte';
  target?: string;
  rel?: string;
}

export default function TrackedCTALink({ href, className, children, location, type = 'phone', target, rel }: PhoneCTALinkProps) {
  const handleClick = () => {
    if (type === 'phone') {
      trackPhoneCall(location);
      if (typeof (window as any).gtag_report_conversion === 'function') {
        (window as any).gtag_report_conversion(href);
      }
    } else if (type === 'whatsapp') trackWhatsAppClick(location);
    else if (type === 'offerte') trackOfferteButtonClick(location);
  };

  return (
    <a
      href={href}
      className={className}
      target={target}
      rel={rel}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
